import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import TextInput from "../../widgets/TextInput";
import MyDatePicker from "../../widgets/DatePicker";
import InsertEsame from "../../widgets/InsertEsame";
import FixButton from "../../widgets/Button";
import DetailsDialog from "../../widgets/DetailsDialog";
import getCorso from "../../services/getCorso";
import getLezioni from "../../services/getLezioni";
import getAllDocuments from "../../services/getAllDocuments";
import updateCorso from "../../services/updateCorso";
import getStudenti from "../../services/getStudenti";
import getLezioniSvolte from "../../services/getLezioniSvolte";
import getPresenzeCorso from "../../services/getPresenzeCorso";
import CheckBox from "../../widgets/CheckBox";
import { NineCellLoading } from 'react-loadingg';
import getMaterie from '../../services/getMaterie';

import updateCorsiRitiroStudente from "../../services/updateCorsiRitiroStudente";

import moment from 'moment';
import Table from '../../widgets/tables/Table';
import addEsame from "../../services/addEsame";
import getEsami from "../../services/getEsami";
import deleteEsame from "../../services/deleteEsame";
import getValutazioniCorso from "../../services/getValutazioniCorso";
import translateString from "../../utils/Locales";
import Utils from "../../utils/utils";
import UploadDocument from "../../widgets/UploadDocument";
import deleteDocument from "../../services/deleteDocument";

let t = translateString;

export default class AddCorso extends React.Component {

	constructor(props){
	super (props)
	
	this.pageDiv = {
		border: '1px solid #cccccc',
		padding: 10
	};
	
	this.section = this.props.section
	if (this.section == undefined){
		const pathname = props.location.pathname;
		this.section = pathname.substring(8, pathname.length);
	}

	this.pageTitle = props.pageTitle;
	this.pageName = props.pageName;
	if (this.pageName == undefined){
		this.pageName = this.section;
	}

	this.userslist = [];
	this.studenti = [];

	this.grid = 2;

	this.startDateRef = React.createRef();
	this.endDateRef = React.createRef();
	const cookies = new Cookies();
	this.dbPath = cookies.get('db_path', { path: '/' });

	this.state = {
		details: [],
		insertEsameShow: false, 
		uploadDocumentShow: false, 
		exams: [], 
		retiredDetails: '', 
		isLoading: true
	};

	}

	async loadEsami(){

	const cookies = new Cookies();
	const username = cookies.get('username', { path: '/' });
	const token = cookies.get('token', { path: '/' });
	const currentCourse = cookies.get('currentCourse', { path: '/' });

	
	this.esami = await getEsami(username, token, this.corso.id);
	this.documents = await getAllDocuments(username, token, currentCourse);
	this.esami.forEach((esame) => {
		esame.tipo = esame.type === '1' ? t('scritto') : esame.type === '2' ? t('orale') : '';
		this.materie.forEach((materia) => {
			if (materia.id === esame.id_materia) {
			esame.materia = materia.materia;
			}
		});
		if (esame.materia === undefined) {
			esame.materia = '';
		}
	});
	this.documents.forEach((doc, i) => {
		if (doc.tipo === '0') {
			this.documents[i].id_mittente = 'Admin'
		}
	})
	}

	async loadComponent() {
	const cookies = new Cookies();
	const username = cookies.get('username', { path: '/' });
	const token = cookies.get('token', { path: '/' });
	const currentCourse = cookies.get('currentCourse', { path: '/' });

	Utils.setAnalyticsPage('Course details: ' + cookies.get('currentCourse', { path: '/' }) + ' - ' + cookies.get('db', { path: '/' }));

	this.corso = await getCorso(username, token, currentCourse);
	this.lezioni = await getLezioni(username, token);
	this.studenti = await getStudenti(username, token);
	this.studenti = this.studenti.filter(s => s.corsi.indexOf(currentCourse+";") != -1);
	this.materie = await getMaterie(username, token);

	this.lezioniSvolte = await getLezioniSvolte(username, token, currentCourse);
	this.presenzeCorso = await getPresenzeCorso(username, token, currentCourse);
	this.valutazioni = await getValutazioniCorso(username, token, this.corso.id);

	await this.loadEsami();

	this.studenti.forEach((studente, index) => {
		var presenze = this.presenzeCorso.filter(p => p.id_studente == studente.id && p.presenza == 1);
		var numeroOreTotali = 0;
		var numeroOreSvolte = 0;
		this.lezioniSvolte.forEach(p => numeroOreTotali += p.durata / 60);
		
		this.lezioniSvolte.forEach(l => {
		var presenze = this.presenzeCorso.filter(p => p.id_studente == studente.id && p.presenza == 1 && p.id_lezione == l.id);
		numeroOreSvolte += presenze[0] == undefined ? 0 : presenze[0].ore != '' && isNaN(parseFloat(presenze[0].ore)) == false ? parseFloat(presenze[0].ore) : l.durata / 60;
		});

		var esamiStudente = this.valutazioni.filter(e => e.id_studente == studente.id && e.valutazione != -1);
		var sommatoriaVoti = 0;
		esamiStudente.forEach(e => sommatoriaVoti += parseFloat(e.valutazione));

		var percent = numeroOreTotali == 0 ? 0 : 100 - parseInt(numeroOreSvolte / numeroOreTotali * 100);
		this.studenti[index].frequencyPercent = percent + "% (" + presenze.length + "/" + this.lezioniSvolte.length + ")";

		this.studenti[index].mediaEsami = esamiStudente.length == 0 ? 'N/A' : (sommatoriaVoti / esamiStudente.length).toFixed(2);
	});

	this.numeroOre = 0;
	this.lezioni = this.lezioni.filter(l => l.id_corso == this.corso.id || l.altri_corsi.indexOf(this.corso.id + ';') != -1);
	this.lezioni.forEach(l => {
		this.numeroOre += l.durata / 60;
	});

	this.setState({corso: this.corso, isLoading: false });
	}

	async componentDidMount(){
	await this.loadComponent();
	}

	render () {

	var headCells = [
		{ id: 'cognome', numeric: true, disablePadding: false, label: t('cognome') },
		{ id: 'nome', numeric: false, disablePadding: true, label: t('nome') },
		{ id: 'mail', numeric: true, disablePadding: false, label: 'Mail' },
		{ id: 'frequencyPercent', numeric: true, disablePadding: false, label: t('perc_assenze') },
		{ id: 'mediaEsami', numeric: true, disablePadding: false, label: t('media_esami') },
		{ id: '_', numeric: true, disablePadding: false, label: '' },
	];
	
	var headCellsEsami = [
		{ id: 'data', numeric: true, disablePadding: false, label: t('data') },
		{ id: 'materia', numeric: false, disablePadding: true, label: t('materia') },
		{ id: 'nome_insegnante', numeric: false, disablePadding: true, label: t('insegnanti') },
		{ id: 'nome', numeric: false, disablePadding: true, label: t('note') },
		{ id: 'tipo', numeric: false, disablePadding: true, label: t('tipologia') },
		{ id: '_', numeric: true, disablePadding: false, label: '' },
	];

	var headCellsDocumenti = [
		{ id: 'filename', numeric: false, disablePadding: false, label: t('file') },
		{ id: 'id_mittente', numeric: false, disablePadding: true, label: t('mittente') },
		{ id: '_', numeric: true, disablePadding: false, label: '' }
	];

		this.searchCols = ['nome', 'cognome', 'mail'];
		this.searchColsEsami = ['data', 'nome'];
		this.searchColsDocumenti = ['filename', 'id_mittente'];

	function createData(username, name, surname) {
		return { username, name, surname };
	}

	var rows = [];
	this.userslist.length > 0 && this.userslist.map((v, k) => {
		rows.push(createData(v.username, v.name, v.surname));
	});

	const cookies = new Cookies();
	const currentCourse = cookies.get('currentCourse', { path: '/' });
	const username = cookies.get('username', { path: '/' });
	const token = cookies.get('token', { path: '/' });

	if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

	if (this.state.corso == undefined) return <div />;

	return (
		<>
		<LoadingOverlay
		active={this.state.isLoading}
		styles={{
		content: () => ({
			position: 'relative',
			width: '100%',
			top: '200px'
		})
		}}
		spinner
		text={'Loading your content...'}
		>
		<PageTitle title={t('edit_corso')} />
			<TextInput name={t('nome')} value={this.state.corso.name} 
					onChange={(text) => { this.setState(prevState => ({
					corso: {
						...prevState.corso,           
						name: text
					}
					}))}
			} />

			<div style={{ marginLeft: 5, display: 'flex', marginBottom: -5 }}>
			<p style={{ marginRight: 5 }}>{t('visibile_studenti')}</p>
			<div style={{ marginTop: 2 }}>
				<CheckBox checked={this.state.corso.visibleStudent == 1 ? true : false} 
				name={t('visibile')} 
				onElementCheck={(val) => { this.setState(prevState => ({
					corso: {
						...prevState.corso,
						visibleStudent: val == true ? 1 : 0
					}
					}))}
				} />
			</div>
			</div><br/>

			<div style={{ marginLeft: 5, display: 'flex', marginTop: -20 }}>
			<p style={{ marginRight: 5 }}>{t('visibile_insegnanti')}</p>
			<div style={{ marginTop: 2 }}>
				<CheckBox checked={this.state.corso.visibleTeacher == 1 ? true : false} 
				name={t('visibile')} 
				onElementCheck={(val) => { this.setState(prevState => ({
					corso: {
						...prevState.corso,           
						visibleTeacher: val == true ? 1 : 0
					}
					}))}
				} />
			</div>
			</div><br/>

			<MyDatePicker ref={this.startDateRef} name={t('data_inizio')} value={this.state.corso.dateStart}/>
			<MyDatePicker ref={this.endDateRef} name={t('data_fine')} value={this.state.corso.dateEnd}/>
			
			<TextInput name={t('anno_accademico')} value={this.state.corso.anno_accademico} 
					onChange={(text) => { this.setState(prevState => ({
					corso: {
						...prevState.corso,           
						anno_accademico: text
					}
					}))}
			} />

			<div style={{ display: 'flex', marginTop: 20, marginLeft: 8 }}>
				<img alt="" src={ require('../../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
				<p style={{ fontSize: 12, color: 'darkgray', maxWidth: '80%' }}>{t('divisione_info')}</p><br/>
			</div>
			<div style={{ marginLeft: 5, display: 'flex', marginTop: -15 }}>
			<p style={{ marginRight: 5 }}>{t('divisione_fatturato')}</p>
			<div style={{ marginTop: 2 }}>
				<CheckBox checked={this.state.corso.divisione_fatturato == 1 ? true : false} 
				name={'Divisione fatturato lezione'} 
				onElementCheck={(val) => { this.setState(prevState => ({
					corso: {
					...prevState.corso,           
					divisione_fatturato: val == true ? 1 : 0
					}
				}))}
				} />
			</div>
			</div><br/>

			<FixButton title={t('salva')} callback={this.save.bind(this)} />

			<br/>

			<br/>
			<div>{t('ore_inserite')} {this.numeroOre}</div>

			<PageTitle title={t('lista_studenti')} button={t('stampa_medie')} onClick={() => {
			window.location.href =  '/' + this.dbPath + '/#/app/pdfFullCourse';
			}}/>
			
			<Table headCells={headCells} searchCols={this.searchCols} currentCourse={currentCourse} addPerson={true} removePerson={true} students={true} calendar={false} pdf={true} excel={false} rows={this.studenti} 
			
			onAddStudent={ async (row) => {
				if (window.confirm(t('riammetti_studente'))) {
					this.studenti.forEach( async (studente) => {
						if (studente.id == row) {
						var corsiRitiroStr = studente.corsi_ritiro;
						
						var newRitiriStr = '';
						corsiRitiroStr.split(';').forEach((corso) => {
							if (corso != currentCourse) newRitiriStr += corso;
						});
						
						await updateCorsiRitiroStudente(username, token, studente.id, newRitiriStr);

						Utils.showSuccess(t('studente_min') + ' ' + studente.nome + ' ' + studente.cognome + ' ' + t('ammesso_corso'));
						await this.loadComponent();
						}
					});
				}
			}}

			onRemoveStudent={ async (row) => {
				if (window.confirm(t('ritira_studente'))) {
				this.studenti.forEach( async (studente) => {
					if (studente.id == row) {
					
					var corsiRitiroStr = studente.corsi_ritiro;
					if (corsiRitiroStr.indexOf(currentCourse+';') == -1) corsiRitiroStr += (currentCourse + ';');
					
					await updateCorsiRitiroStudente(username, token, row, corsiRitiroStr);

					Utils.showInfo(t('studente_min') + ' ' + studente.nome + ' ' + studente.cognome + ' ' + t('ritirato_corso'));
					await this.loadComponent();
					}
				});
				}
			}}

			onPdfClicked={(row) => {

			const currentStudent = this.studenti.filter((studente) => studente.id == row)[0];
			const media = currentStudent.mediaEsami;

			const cookies = new Cookies();
			cookies.set('requestedStudent', row, { path: '/' });
			cookies.set('studentAvg', media, { path: '/' });
			window.location.href =  '/' + this.dbPath + '/#/app/pdfEsameSingoloPage';
			}}
			
			onEventClick={(row) => {

				var details = [];

				this.lezioniSvolte.sort((l1, l2) => {
				var data1 = moment(l1.data, "yyyy-MM-DD HH:mm:ss");
				var data2 = moment(l2.data, "yyyy-MM-DD HH:mm:ss");
				return data1 < data2 ? -1 : 1;
				})

				const esamiStudente = this.valutazioni.filter((esame) => esame.id_studente == row && esame.valutazione != -1 );

				var examsDetails = [];

				this.esami.forEach((esameCorso) => {
					esamiStudente.forEach((esameStudente) => {
						if(esameCorso.id == esameStudente.id_esame) {
						var nota = [];

						nota.push(this.materie.find(m => m.id === esameCorso.id_materia).materia + ' ' + esameCorso.nome.toUpperCase() + ': ' + esameCorso.data);
						nota.push(esameStudente.valutazione);
						examsDetails.push(nota);
						}
					});
				});

				this.lezioniSvolte.forEach(l => {
				var presenza = this.presenzeCorso.filter(p => p.id_lezione == l.id && p.id_studente == row);
				var nota = [];
				if (presenza.length == 0){
					nota.push(l.data);
					nota.push(t('assente').toUpperCase());
				} else {
					const val = (presenza == undefined || presenza[0].presenza == -1 ? t('assente').toUpperCase() : t('presente').toUpperCase());
					nota.push(l.data);
					nota.push(val);
					if (presenza[0].ore != '') nota[1] += ' ' + presenza[0].ore + '/' + l.durata/60;
				} 
				details.push(nota);
				})
				
				const currentStudent = this.studenti.filter((studente) => studente.id == row);
				const studentFullName = currentStudent[0].cognome + ' ' + currentStudent[0].nome;

				this.setState({
				detailsShow: true,
				details: details, 
				exams: examsDetails, 
				retiredDetails: currentStudent[0].corsi_ritiro.includes(this.corso.id+';'),
				studentDetails: studentFullName
				})
			}} />
		<br/>
		<PageTitle title={t('esami')} button={t('aggiungi')} onClick={() => {
			this.setState({insertEsameShow: true})
		}}/>
		<Table headCells={headCellsEsami} searchCols={this.searchColsEsami} calendar={false} excel={false} pdf={true} rows={this.esami} 

			onPdfClicked={(row) => {
				const cookies = new Cookies();
				cookies.set('selectedExam', row, { path: '/' });
				window.location.href =  '/' + this.dbPath + '/#/app/pdfExam';
			}}

			onEventClick={(row) => {
				const cookies = new Cookies();
				cookies.set('currentEsame', row, { path: '/' });
				window.location.href =  '/' + this.dbPath + '/#/app/esameDetails';
				}}  
				
			onDelete={async (id) => {
				if (window.confirm(t('cancella_esame')) == false) return;

				const cookies = new Cookies();
				const username = cookies.get('username', { path: '/' });
				const token = cookies.get('token', { path: '/' });    
				await deleteEsame(username, token, id);
				await this.loadEsami();
				this.setState({});
	
				}}/>

		{ this.state.detailsShow && (
			<DetailsDialog 
				key={Math.random()}
				title={t('dettaglio_presenza')}
				retired={this.state.retiredDetails}
				studentDetails={this.state.studentDetails}
				details={this.state.details}
				exams={this.state.exams}
				materie={this.materie}
				show={this.state.detailsShow}
				onClose={() => this.setState({detailsShow: false})}
			/>
		)}

		<InsertEsame key={Math.random()} 
			show={this.state.insertEsameShow}
			onCancel={() => this.setState({insertEsameShow: false})} 
			onOkClicked={async (id_insegnante, nome_insegnante, id_materia, data, titolo, type) => { 
			const cookies = new Cookies();
			const username = cookies.get('username', { path: '/' });
			const token = cookies.get('token', { path: '/' });

			this.setState({insertEsameShow: false});
			
			var resp = await addEsame(username, token, this.corso.id, id_insegnante, nome_insegnante, id_materia, data, titolo, type);
			await this.loadEsami();
			this.setState({});
			if (resp.result == 'ok') 
				Utils.showSuccess(t('esame_inserito'));
			else 
				Utils.showError(t('errore_imprevisto'));
			}}
			/>
			<br />

			{/*             DOCUMENTI             */}

			<PageTitle title={t('documenti')} button={t('aggiungi')} onClick={() => {
				this.setState({uploadDocumentShow: true})
				}}
			/>
			<Table headCells={headCellsDocumenti} searchCols={this.searchColsDocumenti} download={true} rows={this.documents} 

				onDelete={async (id) => {
					if (window.confirm(t('cancella_file')) == false) return;

					const cookies = new Cookies();
					const username = cookies.get('username', { path: '/' });
					const token = cookies.get('token', { path: '/' });    
					await deleteDocument(username, token, id);
					await this.loadEsami();
					this.setState({});
		
				}}
			/>
			{
				this.state.uploadDocumentShow && (
					<UploadDocument
						corso={this.state.corso}
						key={Math.random()}
						show={this.state.uploadDocumentShow}
						onClose={async () => {
							this.setState({ uploadDocumentShow: false });
							await this.loadEsami();
							this.setState({});
						}}
					/>
				)
			}
		</LoadingOverlay>
		
		</>
	);
	}

	async save (){
		const cookies = new Cookies();
		const username = cookies.get('username', { path: '/' });
		const token = cookies.get('token', { path: '/' });

		const xStartDate = this.startDateRef.current.getDate();
		const xEndDate = this.endDateRef.current.getDate();

		let startDate = moment(xStartDate).format('yyyy-MM-DD');
		let endDate = moment(xEndDate).format('yyyy-MM-DD');

		if (xEndDate < xStartDate){
		Utils.showInfo(t('controlla_date'));
		return;
		}
	
		await updateCorso(username, token, this.state.corso.id, this.state.corso.name, startDate, endDate, this.state.corso.divisione_fatturato, this.state.corso.visibleStudent, this.state.corso.visibleTeacher, this.state.corso.anno_accademico);
		window.location.href =  '/' + this.dbPath + '/#/app/corsi';
	}

}

